import { render, staticRenderFns } from "./cqbyTable.vue?vue&type=template&id=d98b52aa&scoped=true"
import script from "./cqbyTable.vue?vue&type=script&lang=ts"
export * from "./cqbyTable.vue?vue&type=script&lang=ts"
import style0 from "./cqbyTable.vue?vue&type=style&index=0&id=d98b52aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d98b52aa",
  null
  
)

export default component.exports